module.exports = [{
      plugin: require('/tmp/6f39e808/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
